import type { Editor, Node, NodeEntry } from 'slate';

import type { Length } from '../../types';
import { assertNeverThrow, convertUnit } from '../../util';
import type { BreakElement, PageBreakElement, RenderModelBreak } from '../internal';
import {
  isBreakElement,
  isPageBreakElement,
  isRemoveBreakEdit,
  isRenderModelLine,
  isRenderModelParagraph,
  Queries,
} from '../internal';

const breakQueries = {
  isActiveBreak: (node: Node): node is BreakElement =>
    isBreakElement(node) && !node.suggestedEdits?.some(isRemoveBreakEdit),

  isActivePageBreak: (node: Node): node is PageBreakElement =>
    isPageBreakElement(node) && Queries.isActiveBreak(node),

  renderedBreakWidth(
    editor: Editor,
    [rMBreak, rMBreakPath]: NodeEntry<RenderModelBreak>,
    unit: Length.Unit
  ): number {
    if (isPageBreakElement(rMBreak)) {
      const rMParagraphEntry = Queries.renderModelAbove(editor, {
        at: rMBreakPath,
        match: isRenderModelParagraph,
      });
      if (!rMParagraphEntry) throw new Error('Expected paragraph');

      const rMLineEntry = Queries.renderModelAbove(editor, {
        at: rMBreakPath,
        match: isRenderModelLine,
      });
      if (!rMLineEntry) throw new Error('Expected line');

      const [rMParagraph] = rMParagraphEntry;
      const [rMLine] = rMLineEntry;

      const { leftOffsetPx } = Queries.lineOffsetLeftPx(editor, {
        paraProps: rMParagraph,
        rMLine,
      });

      return convertUnit(rMParagraph.widthPx - leftOffsetPx - rMLine.widthPx, 'px', unit);
    }

    assertNeverThrow(rMBreak);
  },
};

export default breakQueries;
